import React, { createContext, useState, useContext } from "react";

export const EventFormContext = createContext(null);

const EventFormProvider = ({ children }) => {
  const [showSportDataConfig, setShowSportDataConfig] = useState(false);
  return (
    <EventFormContext.Provider
      value={{
        showSportDataConfig,
        setShowSportDataConfig,
      }}
    >
      {children}
    </EventFormContext.Provider>
  );
};

export const useEventFormContext = () => {
  const context = useContext(EventFormContext);
  if (context === undefined) {
    throw new Error("useEventFormContext must be used within a EventFormProvider");
  }
  return context;
};

export default EventFormProvider;
